import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63a3af8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: [20,0] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 0,
            xl: 16
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: $data.request.data.list.length===0,
                active: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, {
                    to: `${_ctx.$Enum.RouterEnum.NewsDetail}?id=${$data.request.data.list[0].article_id}`,
                    class: "card card_big"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", {
                        style: _normalizeStyle({backgroundImage:`url('${$data.request.data.list[0].article_cover_address}')`})
                      }, null, 4 /* STYLE */),
                      _createVNode(_component_a_typography_title, { level: 5 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($data.request.data.list[0].article_title), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["to"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: $data.request.data.list.length===0,
                active: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: [20,_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD)?20:0]
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.request.data.list, (item, index) => {
                        return (_openBlock(), _createBlock(_component_a_col, {
                          xs: 24,
                          md: 8,
                          xl: index===0?0:24
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: `${_ctx.$Enum.RouterEnum.NewsDetail}?id=${item.article_id}`,
                              class: "card"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("i", {
                                  style: _normalizeStyle({backgroundImage:`url('${item.article_cover_address}')`})
                                }, null, 4 /* STYLE */),
                                _createVNode(_component_a_typography_title, { level: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.article_title), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["xl"]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["gutter"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}